import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';

declare var grecaptcha: {
  enterprise: { execute: (arg0: string, arg1: { action: string }) => any };
};

@Injectable({
  providedIn: 'root',
})
export class RecaptchaService {
  constructor(private readonly configService: ConfigService) {}

  public async captchaTokenHeaders(action: string) {
    if (!this.configService.ENABLE_RECAPTCHA) {
      return new HttpHeaders();
    }
    const captchaAction = await this.executeCaptchaAction(action);
    const headers = new HttpHeaders();
    return headers.set('x-token', captchaAction);
  }

  public async executeCaptchaAction(action: string) {
    return await grecaptcha.enterprise.execute(this.configService.RECAPTCHA_KEY, { action });
  }
}
